import React from 'react';
import { Form, Col, Row, Select } from 'antd';
import { FormInstance } from 'antd/lib/form';
import HeroTitle from 'components/theme_components/HeroTitle';
import AddressCard from './AddressCard';
import { useQuery } from 'react-query';
import { getThirdPartyAddresListByTpid } from 'services/thirdParty';
import Title from 'components/Title';
import ModalSFS from 'components/theme_components/ModalSFS';
import AddresseModal from './AddresseModal';
import { PlusOutlined } from '@ant-design/icons';
import GetLabel from 'DisplayFramework/components/GetLabel';
import ButtonOperation from 'components/ButtonOperation';
import TaskSButtonSFS from 'pages/workflow/workflowSFS/TasksButtonSFS';

export type AddressListProps = {
  tpid: number;
  form: FormInstance;
  color: string;
  itemsCompanyHierarchyTree: any[];
  tptype: string;
  onDone: any
};

const AddressList = ({ tpid, form, color, itemsCompanyHierarchyTree, tptype, onDone }: AddressListProps) => {
  const { data: Adresses, refetch } = useQuery(
    ['getThirdPartyAddresListAction', { tpid: Number(tpid) }],
    () =>
      getThirdPartyAddresListByTpid({ tpid: Number(tpid) }).then(
        (res) => res.list || []
      ),
    { enabled: !!tpid }
  );
  const done = () => {
    onDone();
    // form.submit();
  };
  return (
    <Form form={form} className="">
      <div className='site-layout-background'>

        <HeroTitle form={form} display title={`address${tptype}`} color={color} itemsCompanyHierarchyTree={itemsCompanyHierarchyTree} />

        <div style={{ padding: '40px 24px' }}>
          <Row gutter={[16, 16]} className="ml-0 mr-0 pb-20 ">
            {Adresses &&
              Adresses.map((address, index) => (
                <Col span={12} key={index}>
                  <AddressCard address={address} tpid={tpid} refetch={refetch} onDone={onDone} />
                </Col>
              ))}
          </Row>
          <Row gutter={[16, 16]} justify="center" className="ml-0 mr-0 pb-20 " style={{ marginTop: 30 }}>
            <Col>
              {/* <ModalSFS
                trigger={({ setVisible }) => (
                  <a onClick={() => setVisible(true)} style={{ display: 'flex' }}>
                    <PlusOutlined className="color-orange font-size-16 cursorpointer" style={{ marginRight: '13px' }} />

                    <GetLabel
                      label="Ajouter une adresse"
                      className="font-size-18 floatRight ml-14 cursorpointer"
                      style={{ color: '#4B5672', fontWeight: 500 }}
                    />

                  </a>
                )}
                title="Ajouter une adresse"
              >
                <AddresseModal
                  tpid={Number(tpid)}
                  setVisible={() => false}
                  refetch={refetch}
                />
              </ModalSFS> */}

              <TaskSButtonSFS
               
                clientName=""
                entityId={tpid}
                entityReference=""
                entityName="THIRDPARTY"
                tptype={tptype}
                title=""
                currcode=""
                funcode="evChangeAddress"
                refetch={refetch}
                >

                <ButtonOperation comcode="addadress" className='ut-btn-bordred' icon={<PlusOutlined className="color-orange font-size-20 cursorpointer mr-5 " />} />
              </TaskSButtonSFS>
            </Col>
          </Row>
        </div>

      </div>


    </Form>
  );
};

export default AddressList;
